import React, { FunctionComponent, useRef, useEffect } from "react";
import styles from "./Quote.module.scss";
import QuoteProps from "./QuoteProps.interface";
import IconViewer from "components/IconViewer/IconViewer";
import useRect from "../../hooks/useRect";

const Quote: FunctionComponent<QuoteProps> = (props) => {
    const { setQuoteWidth } = props;
    const slideListRef = useRef<HTMLDivElement>(null);
    const rect = useRect(slideListRef);

    useEffect(() => {
        setQuoteWidth(-rect.width);
    }, [rect.width]);

    return (
        <div className={styles.wrapper} ref={slideListRef}>
            <div className={styles.container} >
                {props.settings.showIcon ? (
                    <IconViewer className={styles.quote_icon} name="quote" />
                ) : null}

                {props.content.text ? (
                    <div className={styles.text}>
                        {props.content.text}
                    </div>
                ) : null}

                {props.content.author ? (
                    <div className={styles.author_wrapper}>
                        <span className={styles.author}>{props.content.author}</span>

                        {props.content.authorTitle ? (
                            <div>{props.content.authorTitle}</div>
                        ) : null}
                    </div>
                ) : null}
            </div>

        </div>
    );
};

export default Quote;